import { FC, MouseEvent, PropsWithChildren, useState } from 'react';

import MenuContext, { MenuContextValues } from './context';

export type MenuProviderProps = PropsWithChildren<
  Partial<Pick<MenuContextValues, 'onClose' | 'onOpen' | 'open'>>
>;

const MenuProvider: FC<MenuProviderProps> = props => {
  const { children } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const onOpen = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
    props.onOpen?.(e);
    setOpen(true);
  };

  const onClose = () => {
    props.onClose?.();
    setOpen(false);
  };

  const values: MenuContextValues = {
    anchorEl,
    onClose,
    onOpen,
    open: props.open || open,
    setOpen,
  };

  return <MenuContext.Provider value={values}>{children}</MenuContext.Provider>;
};

export default MenuProvider;
